import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idiomaNombre'
})
export class IdiomaNombrePipe implements PipeTransform {
  private idiomas: { [key: string]: string } = {
    es: 'Español',
    en: 'Inglés',
    fr: 'Francés',
    de: 'Alemán',
    it: 'Italiano',
    pt: 'Portugués',
    ru: 'Ruso',
    zh: 'Chino',
    ja: 'Japonés',
    ko: 'Coreano'
    // Agrega más según necesites
  };

  transform(codigo: string): string {
    return this.idiomas[codigo.toLowerCase()] || codigo;
  }
}
